import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { generatePath, Link, useNavigate } from 'react-router-dom';
import { EyeOutlined, GlobalOutlined, UserOutlined } from '@ant-design/icons';
// import styles from './index.module.scss';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import ImageCol from '@components/common/table/ImageCol';
import { AppConstants, categoryKind, DEFAULT_FORMAT, DEFAULT_TABLE_ITEM_SIZE, DEFAULT_TABLE_ITEM_SIZE_LARGE, deviceInwensKinds, INWEN_KIND_HUB } from '@constants';
import apiConfig from '@constants/apiConfig';
import { FieldTypes } from '@constants/formConfig';
import { statusOptions } from '@constants/masterData';
import useFetch from '@hooks/useFetch';
import useListBase from '@hooks/useListBase';
import useNotification from '@hooks/useNotification';
import useTranslate from '@hooks/useTranslate';
import { AvatarField, BaseTable,BaseTooltip } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { convertUtcToLocalTime } from '@utils';
import { Button, Modal, Tag } from 'antd';

import routes from './routes';
const message = defineMessages({
    objectName: 'devices',
});

const DeviceManagerListPage = () => {
    const translate = useTranslate();
    const navigate = useNavigate();
    const notification = useNotification();
    const statusValues = translate.formatKeys(statusOptions, [ 'label' ]);
    const [ showPreviewModal, setShowPreviewModal ] = useState(false);

    const { data, mixinFuncs, queryFilter, loading, pagination } = useListBase({
        apiConfig: apiConfig.inwenDevice,
        options: {
            pageSize: DEFAULT_TABLE_ITEM_SIZE_LARGE,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.mappingData = (response) => {
                if (response.result === true) {
                    return {
                        data: response.data.content,
                        total: response.data.totalElements,
                    };
                }
            };
        },
    });

    const columns = [
        {
            title: <FormattedMessage defaultMessage="Name" />,
            dataIndex: 'inwenDeviceName',
            key: 'inwenDeviceName',
        },
        {
            title: <FormattedMessage defaultMessage="Device Serial" />,
            dataIndex: 'inwenDeviceSerial',
            key: 'inwenDeviceSerial',
        },
        {
            title: <FormattedMessage defaultMessage="Kind" />,
            dataIndex: 'kind',
            key: 'kind',
            render: (kind) => (kind === INWEN_KIND_HUB ? 'Hub' : 'Iwens'),
        },
       
        mixinFuncs.renderActionColumn(
            {
                edit: true,
                delete: true,
            },
            { width: '120px' },
        ),
    ];

    const searchFields = [
        {
            key: 'inwenDeviceName',
            placeholder: translate.formatMessage(commonMessage.Name),
        },
        {
            key: 'kind',
            placeholder: translate.formatMessage(commonMessage.Kind),
            type: FieldTypes.SELECT,
            options: deviceInwensKinds,
            colSpan: 4,
        },
    ];

    return (
        <PageWrapper
            routes={[ { breadcrumbName: translate.formatMessage(commonMessage.Device) } ]}
        >
            <ListPage
                searchForm={mixinFuncs.renderSearchForm({ fields: searchFields, initialValues: queryFilter })}
                actionBar={mixinFuncs.renderActionBar()}
                baseTable={
                    <BaseTable
                        onChange={mixinFuncs.changePagination}
                        columns={columns}
                        dataSource={data}
                        // loading={loading || getCategoriesLoading || updateNewsPinLoading}
                        pagination={pagination}
                    />
                }
            />
            <Modal
                title={<FormattedMessage defaultMessage="Preview" />}
                width={1000}
                open={showPreviewModal}
                footer={null}
                centered
                onCancel={() => setShowPreviewModal(false)}
            >
                {/* {newsContent && (
                    <div className={styles.previewContent} dangerouslySetInnerHTML={{ __html: newsContent }}></div>
                )} */}
            </Modal>
        </PageWrapper>
    );
};

export default DeviceManagerListPage;
